import React from 'react';
import {
  assignmentWorkEditorConfig,
  ClassroomTeacherWorkEditorPage,
} from './ClassroomTeacherWorkEditorPage';

const ClassroomTeacherAssignmentEditorPage: React.FC = () => (
  <ClassroomTeacherWorkEditorPage config={assignmentWorkEditorConfig} />
);

export default ClassroomTeacherAssignmentEditorPage;
